import React, { useEffect, useState } from "react";
import "../style.css";
import NavBar from "components/SideBar/SideBar2";
import { ToastContainer } from "react-toastify";
import { RingLoader } from "react-spinners";
import { Button } from "@material-ui/core";
import {
  getEntityList,
  profileInfo,
  setDefaultEntity,
  setPeriodStore,
  setPeriodStoreSingle,
  storeSelectedGstinGSTR2A2BNEW,
} from "../action";
import { useDispatch, useSelector } from "react-redux";
import Gstr2a2bFilter from "../Utility/Filter";
import { CustomTextField, getLastDateOfMonth } from "../Utility/utility";
import SearchIcon from "@material-ui/icons/Search";
import { InputAdornment } from "@material-ui/core";
import downloadWhite from "images/downloadWhite.svg";
import Container from "containers/anx1/SharedModule/DropdownTreeContainer";
import { DropdownDateRangePicker } from "../Utility/SelectDateRange";
import Table from "./Table";
import { downloadITCExcel, getITCData, setITCTableData } from "./action";
import { errorToastMessage } from "utils/errorToast";
import { COMMON_MSGS } from "Constant/Messages";
import { markIn3b, recoStatus } from "./constants";

const Gstr2A2BITCregister = (props) => {
  const [recoType, setRecoType] = useState([]);
  const [mark3bType, setMark3bType] = useState([]);
  const [search, setSearch] = useState("");
  const dispatch = useDispatch();
  const {
    startDate,
    endDate,
    entityMasterList,
    profileData,
    defaultEntity,
    selectedGstin,
  } = useSelector((store) => store.gstr2a2bNewCommonReducer);

  const { itcTableData, loaderStatus } = useSelector(
    (store) => store.gstr2a2bNewITCReducer
  );
  const [dateRange, setDateRange] = useState([
    {
      startDate: startDate,
      endDate: endDate ? getLastDateOfMonth(endDate) : endDate,
      key: "selection",
    },
  ]);

  const handleDataTypeFilter = (currentNode, selectedNodes) => {
    let selectedValues = selectedNodes.map((node) => node.value);
    setRecoType(selectedValues);
  };
  const handle3bTypeFilter = (currentNode, selectedNodes) => {
    let selectedValues = selectedNodes.map((node) => node.value);
    setMark3bType(selectedValues);
  };

  const handleDownload = () => {
    if (itcTableData?.length > 0) {
      dispatch(downloadITCExcel(itcTableData));
    } else {
      errorToastMessage("No Data available to download");
    }
  };

  const handleGenerateReport = (search = "", msgFlag = true) => {
    if (
      defaultEntity &&
      selectedGstin?.length > 0 &&
      startDate &&
      endDate &&
      recoType?.length > 0 &&
      mark3bType?.length > 0 &&
      dateRange[0].startDate &&
      dateRange[0].endDate
    ) {
      dispatch(
        getITCData(
          selectedGstin,
          startDate,
          endDate,
          dateRange,
          recoType,
          mark3bType
        )
      );
    } else {
      if (msgFlag === true) {
        errorToastMessage(COMMON_MSGS.ENTER_MANDATORY_FIELDS);
      }
    }
  };
  const handleInputChange = (event) => {
    setSearch(event.target.value);
  };

  useEffect(() => {
    dispatch(getEntityList());
  }, []);

  useEffect(() => {
    return () => {
      dispatch(setITCTableData([]));
      console.log("Selected filters cleared on component unmount");
      dispatch(setDefaultEntity(""));
      dispatch(storeSelectedGstinGSTR2A2BNEW([]));
      dispatch(profileInfo([]));
      dispatch(setPeriodStoreSingle(null));
      dispatch(setPeriodStore(null, null));
    };
  }, []);

  return (
    <div>
      <NavBar
        currentPage={"GSTR-2A/2B  | ITC Register"}
        module="gstr2a2bNew"
        history={props.history}
      >
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <div className="sweet-loading">
          <RingLoader size={100} color={"#123abc"} loading={loaderStatus} />
        </div>
        <div style={{ display: "flex" }}>
          <div style={{ width: "65%" }}>
            <Gstr2a2bFilter
              entityMasterList={entityMasterList}
              profileData={profileData}
              retPeriodWidth={"28%"}
            />
          </div>
          <div style={{ width: "25%" }} className="dropdown-container-gstr2a2b">
            <label
              style={{
                fontFamily: "GT-Walsheim-medium",
                fontSize: "12px",
                // marginBottom: "2px",
              }}
            >
              Select Document Date Range*
            </label>
            <DropdownDateRangePicker
              initialStartDate={startDate}
              initialEndDate={endDate}
              minDate={startDate}
              maxDate={endDate}
              width={"215px"}
              setDateRange={setDateRange}
              dateRange={dateRange}
              selection={startDate && endDate}
            />
          </div>
        </div>
        <div style={{ width: "86%" }}>
          <div style={{ display: "flex", justifyContent: "flex-start" }}>
            {/* <div
              style={{ width: "25%" }}
              className="dropdown-container-gstr2a2b"
            >
              <label
                style={{
                  fontFamily: "GT-Walsheim-medium",
                  fontSize: "12px",
                  // marginBottom: "2px",
                }}
              >
                Select Document Date Range*
              </label>
              <DropdownDateRangePicker
                initialStartDate={startDate}
                initialEndDate={endDate}
                minDate={startDate}
                maxDate={endDate}
                width={"215px"}
                setDateRange={setDateRange}
                dateRange={dateRange}
              />
            </div> */}

            <div
              style={{ width: "24.2%", marginLeft: "0.3em",zIndex:100 }}
              className="dropdown-container-gstr2a2b"
            >
              <label
                style={{
                  fontFamily: "GT-Walsheim-medium",
                  fontSize: "12px",
                  // marginBottom: "2px",
                }}
              >
                Select Reco Status*
              </label>
              <Container data={recoStatus} onChange={handleDataTypeFilter} />
              {/* <CustomMultipleSelect
                value={recoStatus}
                handleChange={handleChangeRecoType}
                selected={recoType}
                title={"Select Reco Status"}
              /> */}
            </div>

            <div
              style={{ width: "19%", marginLeft: "1.7em",zIndex:100 }}
              className="dropdown-container-gstr2a2b"
            >
              <label
                style={{
                  fontFamily: "GT-Walsheim-medium",
                  fontSize: "12px",
                  // marginBottom: "2px",
                }}
              >
                Select Mark in 3B*
              </label>
              <Container data={markIn3b} onChange={handle3bTypeFilter} />
              {/* <CustomMultipleSelect
                value={markIn3b}
                handleChange={handleChange3bType}
                selected={mark3bType}
                width="160px"
                title={"Select Mark in 3b"}
                menuWidth="160px"
                marginLeft="2px"
              /> */}
            </div>

            <Button
              onClick={handleGenerateReport}
              type="submit"
              variant="contained"
              color="primary"
              style={{
                backgroundColor: "#4f2d7f",
                color: "white",
                marginTop: "27.5px",
                // marginRight: "7.7em",
                marginLeft: "1em",
                height: "32px",
                fontSize: "12px",
                textTransform: "capitalize",
              }}
            >
              Generate Report
            </Button>
          </div>
        </div>
        {/* <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            marginTop: "0.6em",
          }}
        >
          <div style={{ width: "35%" }}>
            <CustomTextField
              style={{ backgroundColor: "white" }}
              placeholder="Search"
              variant="outlined"
              size="small"
              onChange={handleInputChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </div>

          <Button
            onClick={handleDownload}
            type="submit"
            variant="contained"
            color="primary"
            style={{
              backgroundColor: "#4f2d7f",
              color: "white",
              marginTop: "5px",
              marginLeft: "1em",
              height: "32px",
              fontSize: "12px",
              textTransform: "capitalize",
            }}
          >
            <img
              src={downloadWhite}
              alt="Download"
              style={{
                width: "30px",
                height: "20px",
                paddingBottom: "3px",
              }}
            />
          </Button>
        </div> */}
        <Table />
      </NavBar>
    </div>
  );
};

export default Gstr2A2BITCregister;
